module.exports = __webpack_public_path__ + "product-reviews-info.svg?925dfcb8ff62e98f7fa9ee03a33ae734";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/product-reviews-info.svg
// module id = 314
// module chunks = 2